import React from 'react';


function StudentsScreen(props){
  return (
    <div id="students-screen" className={`${props.className} dashboard-container`}>
      <h1>this is a Students Screen</h1>
    </div>
  )
}

export default StudentsScreen;